import {BrandConfig} from './types';

const anna: BrandConfig = {
  key: 'anna',
  appName: 'Anna Lottery',
  appSortName: 'ANNA',
  themeColor: '#FFFFFF',
  mainDescription:
    'Anna Lottery most popular betting games in india, in 2023 one of the best betting game app. Including games for 3 Digit Games, Kerala lottery, Satta Matka and Color predictions games. You can watch free IPL Live on anna app and bet for the IPL sports games.',
  mainKeywords:
    'Kerala State Lotteries,Directorate of Kerala State Lotteries,Kerala Lottery,state lotteries,state lottery,lottery results,lottery prize,lottery price,lottery agents,lottery claim,KERALA STATE LOTTERY,KERALA STATE LOTTERIES,DIRECTORATE OF KERALA STATE LOTTERIES,LOTTERY,LOTTERIES,STATE LOTTERIES,KERALA LOTTERY,LOTTERY RESULTS,LOTTERY PRIZE,LOTTERY PRICE,LOTTERY AGENTS,LOTTERY STRUCTURE,Onam Bumper lottery,christmas new year bumper lottery,Pooja bumper lottery,Vishu Bumper lottery,Monsoon Bumper lottery,summer bumper lottery,ONAM BUMPER LOTTERY,CHRISTMAS NEWYEAR BUMPER LOTTERY,POOJA BUMPER LOTTERY,VISHU BUMPER LOTTERY,MONSOON BUMPER LOTTERY,SUMMER BUMPER, Weekely lotteries,WEEKELY LOTTERIES,WIN WIN LOTTERY,NIRMAL LOTTERY,AKASHYA LOTTERY,KARUNYA LOTTERY,KARUNYA PLUS LOTTERY,STHREESAKTHI LOTTERY,Win win lottery,nirmal lottery,Akashya lottery,Karunya lottery,Karunya plus lottery,Sthreesakthi lottery, Lottery Draw,LOTTERY DRAW,LOTTERY VENUE,lottery venue,lottery prize results,lottery prize claim,LOTTERY PRIZE RESULTS,LOTTERY PRIZE CLAIM,anna lottery,lottery anna,anna,anna lotto,lotto anna,india lottery',
  shareImage: 'https://lotteryanna.com/images/share-bg.jpg',
  supportEmail: 'support@annalotteryofficial.in',
  packageId: 1,
  packageInfo: 'com.lottepro.sambadpro',
  defaultChannel: 'anna',
  disabledPhoneCode: true,
  apiSendPhoneCode: false,
  defaultPhoneCode: '91',
  homePage: 'Index',
  defaultApkPath: 'anna',
  defaultApkName: 'AnnaLottery_ins.apk',
  defaultApkPrefix: 'AnnaLottery_',
  gameNavigateVersion: 1,
  linkingPrefixes: ['https://lotteryanna.com', 'anna://'],
  fonts: {
    inter: 'Inter',
    interBold: 'Inter-Bold',
    din: 'din',
    dinMid: 'din-mid',
    dinBold: 'din-bold',
    dinBlack: 'din-black',
    anybody: 'Anybody',
  },
  theme: {
    basicColor: {
      primary: '#E91100',
      primaryLinearGradient: ['#E91100', '#FF891C'],
      proxyLinearGradient: ['rgba(233,17,0,0.00)', '#C91103'],
      proxybgColor: '#E91100',
      proxyResetLink: '#FFEFEF',
      proxylightLinear: ['#E91100', '#FF891C'],
      loginLinearGradient: ['#FFFFFF', '#FFDEDB'],
      rechargeButtonLinearGradient: ['#E91100', '#E91100'],
      invitationRecordLinearGradient: ['#FBCBCB', 'rgba(255, 255, 255, 0.00)'],
      red: '#FF382C',
      darkPrimary: '#B40000',
      lightPrimary: '#F7F0FF',
      invitationRuleColors: {
        tableHeader: '#DB0000',
        tableEven: '#FFD5D5',
        tableOdd: '#FFE6E8',
      },
    },
    fontColor: {
      main: '#000000',
      second: '#31373D',
      accent: '#5F6975',
      secAccent: '#9FA5AC',
      grey: '#D8E0EA',
      colorMyBets: '#463737',
    },
    backgroundColor: {
      main: '#E91100',
      second: '#F15802',
      accent: '#00DEDE',
      secAccent: '#F15802',
      grey: '#EEEEEE',
      palegrey: '#E0E4EE',
      lightGrey: '#F4F6FB',
      wonLinearGradient: ['rgba(241, 88, 2, 0.08)', 'rgba(241, 88, 2, 0)'],
      noWinLinearGradient: ['#F0F0F0', 'rgba(240, 240, 240, 0)'],
      toDrawnLinearGradient: [
        'rgba(23, 118, 255, 0.08)',
        'rgba(23, 118, 255, 0)',
      ],
      blue: '#1776FF',
      orange: '#F15802',
      blueGrey: '#B0AEA0',
      palegreyNext: '#F6F7FA',
      timeLinearGradient: ['#FCD1D1', '#FFFFFF'],
      remainingLinearGradient: ['#FFD9D9', '#FFF0F0'],
      ruleBtn: '#FFFAFA',
      colorQuickLinearGradient: ['#FFDBDB', '#FFEAEA'],
      colorBall: '#D5B6B6',
      rateItem: '#F6E9FF',
      colorBets: '#BCA4A4',
      diceResultBg: '#D89898',
      diceResultBgLight: '#FFC5C5',
      colorBetsListBg: '#806D6D',
      colorBetsListBgLight: '#A68B8B',
      colorBetsDotBg: '#776464',
      betsBgLight: '#F7F0FF',
      betsBgDark: '#B40000',
      colorDashed: '#897AA1',
      sattaDigitShadow: '#D8989880',
    },
    invitationBaseColors: {
      signGiftBgColor: '#F15802',
      registSuccess: '#009B22',
    },
  },
  mainTabs: [
    {name: 'Home', link: 'index/home'},
    {name: 'Result', link: 'index/result'},
    {name: 'Referral', link: 'index/referral'},
    {name: 'Me', link: 'index/me'},
  ],
};

export default anna;
